import React, { Fragment, useContext, useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import InputField from '../../lib/ui/inputs/Input';
import { LangCtx } from "../../lib/context";
import "../../layouts/Layouts.css";
import "../../ui-styles/buttons/ButtonTxt.css";
import { toast } from 'react-toastify';
import { forgotPassword, forgotPasswordSubmit, postPrevent } from "../../actions/users";
// import config from "../../config.json";
import { Auth } from "aws-amplify";
import { validatePassword } from "../../lib/validation";
import OtpInput from 'react-otp-input';
// import TxtBtn from "../../lib/ui/buttons/TxtButton";
import LogoBranding from '../../lib/ui/logoBranding/LogoBranding';
import md5 from "md5";

const ResetPassword = (props) =>
{
    const history = useHistory();
    const { l } = useContext(LangCtx);
    const [ code, setCode ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ confPassword, setConfPassword ] = useState('');
    const [ errorMsg, setErrorMsg ] = useState('');
    const [ error, setError ] = useState({});
    const [ counter, setCounter ] = useState(120);
    const [ isLoading, setLoading ] = useState(false);
    useEffect(() =>
    {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [ counter ]);

    const handleForgotPwd = (e) =>
    {
        e.preventDefault();
        let uname = new URLSearchParams(props.location.search).get("username");
        const userName = decodeURIComponent(uname);
        try
        {
            if (process.env.REACT_APP_isOffline === "true")
            {
                forgotPassword(userName)
                    .then(res =>
                    {
                        setErrorMsg('');
                        toast.success(res.data, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setCounter(120);
                    })
                    .catch(err =>
                    {
                        console.log("err", err);
                        setErrorMsg(l.went_worng_pls_try_again);
                    });
            } else
            {
                Auth.forgotPassword(userName)
                    .then(data =>
                    {
                        toast.success(l.OTP_sent_your_registered_username, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setCounter(120);
                    })
                    .catch(err =>
                    {
                        console.log("err", err);
                        setErrorMsg(l.went_worng_pls_try_again);
                    });
            }
        } catch (e)
        {
            console.log("Error", e);
            setErrorMsg(l.went_worng_pls_try_again);
        }
    };

    const validate = () =>
    {
        let _error = {};
        let returnValue = true;

        if (code === '')
        {
            _error[ 'code' ] = l.pls_enter_otp;
            returnValue = false;
        }
        else if (code.length !== 6)
        {
            _error[ 'code' ] = l.pls_check_otp;
            returnValue = false;
        }
        if (password === '')
        {
            _error[ 'password' ] = l.pls_ent_new_pwd;
            returnValue = false;
        }
        else if (!validatePassword(password))
        {
            _error[ 'password' ] = l.ent_valid_pwd;
            returnValue = false;
        }
        if (confPassword === '')
        {
            _error[ 'confirmPassword' ] = l.pls_ent_conf_pwd;
            returnValue = false;
        }
        else if (password !== confPassword)
        {
            _error[ 'password' ] = l.psw_confpsw_should_same;
            _error[ 'confirmPassword' ] = l.psw_confpsw_should_same;
            returnValue = false;
        }

        setError(_error);
        return returnValue;
    };


    const  getSubdomain = () => {
        const { hostname } = window.location;
      
        if (hostname === 'localhost') {
          return process.env.REACT_APP_defaultdomian;
        }
      
        const domainParts = hostname.split('.');
        if (domainParts.length > 2) {
          return domainParts[0];
        }
      
        return '';
      }
      
    const handleResetPwd = (e) =>
    {
        e.preventDefault();
        try
        {
            if (!isLoading)
            {
                let uname = new URLSearchParams(props.location.search).get("username");
                const username = decodeURIComponent(uname);

                if (validate())
                {
                    setLoading(true);
                    if (process.env.REACT_APP_isOffline === "true")
                    {
                        const userId = new URLSearchParams(props.location.search).get("userId");
                        let body = {
                            phone: username,
                            userId: userId,
                            otp: code,
                            password: password
                        };
                        forgotPasswordSubmit(body)
                            .then(data =>
                            {
                                setErrorMsg('');
                                setLoading(false);
                                toast.success(l.pwd_upd_succ, {
                                    position: toast.POSITION.TOP_RIGHT
                                });
                                history.push('/');
                            })
                            .catch(err =>
                            {
                                console.log(err);
                                setLoading(false);
                                setErrorMsg(err.message);
                            });
                    } else
                    {
                        Auth.forgotPasswordSubmit(username, code, password)
                            .then(data =>
                            {
                                postPrevent({id: md5(password), email:username, subdomain:getSubdomain()})
                                setErrorMsg('');
                                setLoading(false);
                                toast.success(l.pwd_upd_succ, {
                                    position: toast.POSITION.TOP_RIGHT
                                });
                                history.push('/');
                            })
                            .catch(err =>
                            {
                                console.log(err);
                                setErrorMsg(err.message);
                                setLoading(false);
                            });
                    }
                }
            }

        } catch (e)
        {
            console.log("Error", e);
            setErrorMsg(l.went_worng_pls_try_again);
        }
    };

    // const handleCode = (e) =>
    // {
    //     let value = e.target.value;
    //     let id = Number(e.target.id);
    //     let _code = setCharAt(code, id, value);
    //     setCode(_code);
    // };

    // const setCharAt = (str, index, chr) =>
    // {
    //     //if (index > str.length - 1) return str;
    //     return str.substring(0, index) + chr + str.substring(index + 1);
    // };

    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential overRightjtcCenter mrgnVAuto">
                    <div className="bodyRow fullHightJC">
                        <div className="brandingBlock">
                            <LogoBranding />
                        </div>
                        <div className="crdRowBlock justifyCenter">
                            <h2 className="headingTxt">{l.reset_pwd}</h2>
                        </div>
                        <div className="crdRowBlock alignCenter justifyCenter">
                            <p className="pTxt txtCenter">{l.reset_msg}</p>
                        </div>
                        <div className="crdFormBlock justifyCenter">
                            <p className="smallPTxt txtCenter">{l.pwd_security}</p>
                        </div>
                        <div className="crdFormBlock mrgTop16">
                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }

                            {/* <div className="secondaryLinkBox">
                    <p className="pTxt">Code expires in: <span className="redTxt">4s</span></p>
                </div>
                <div className="secondaryLinkBox">
                    <p className="pTxt"><Link to="/forgot-password" className="linkTxt">Resend OTP</Link></p>
                </div> */}
                            <div className="colBlock">
                                <form id="resetPswform" onSubmit={handleResetPwd} autoComplete="off" >
                                    <div className="inputRowGroup">
                                        <small className="inpLabel">{l.enter_otp}:</small>
                                        {/* <div className="otpInput">
                                        <input id="1" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                        <input id="2" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                        <input id="3" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                        <input id="4" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                        <input id="5" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                        <input id="6" type="text" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" onChange={handleCode} />
                                    </div> */}
                                        <OtpInput className="otpInput"
                                            value={code}
                                            onChange={setCode}
                                            id="otp"
                                            numInputs={6}
                                            // separator={<span>-</span>}
                                            containerStyle={{ flex: 1, width: "100%" }}
                                            autocomplete="off"
                                            focusStyle={{ borderColor: "#24a4c4" }}
                                            // inputStyle={{width:"14%"}}
                                            shouldAutoFocus={true}
                                        />
                                        {(error && error.code) && <span className="inputErrorMsg">{error.code}</span>}
                                    </div>
                                    <div className="rowBlock">
                                        {counter > 0 ? <p className="smallPTxt mrgTop8">{l.code_exp_txt} <span className="linkTxt redTxt">{counter + ' s'}</span></p>
                                            :
                                            <div className="txtLinkRowBlock">
                                                <p className="smallPTxt">{l.resend_otp_txt}</p>
                                                <button className="btnTxt" onClick={handleForgotPwd}>
                                                    <span className="linkTxt linkTxtMd">{l.resend_otp}</span>
                                                </button>
                                            </div>
                                            // <Link to="" onClick={handleForgotPwd} className="linkTxt">{l.resend_otp}</Link>
                                        }
                                    </div>
                                    {/* <small className="inpLabel">{l.enter_otp}<span className="redTxt">*</span>:</small>
                                    <InputField
                                        placeholder={l.enter_otp}
                                        type="text"
                                        error={error && error.code}
                                        errorMsg={error.code}
                                        onChange={(e) => setCode(e.target.value.trim())}
                                        value={code}
                                    /> */}
                                    <small className="inpLabel">{l.new_pwd}:</small>
                                    <InputField
                                        placeholder={l.ent_new_pwd}
                                        type="password"
                                        error={error && error.password}
                                        errorMsg={error.password}
                                        maxLength="30"
                                        onChange={(e) => setPassword(e.target.value.trim())}
                                        autocomplete="off"
                                        value={password}
                                        showPwd={true}
                                    />
                                    {/* <span className="smallPTxt">{l.pwd_security}</span> */}
                                    <small className="inpLabel">{l.confirm_pwd}:</small>
                                    <InputField
                                        placeholder={l.conf_new_pwd}
                                        type="password"
                                        error={error && error.confirmPassword}
                                        errorMsg={error.confirmPassword}
                                        autocomplete="off"
                                        onChange={(e) => setConfPassword(e.target.value.trim())}
                                        value={confPassword}
                                        showPwd={true}
                                        maxLength="30"
                                    />

                                    <div className="crdBtnContainer">
                                        <Button onClick={handleResetPwd}
                                            label={l.reset_pwd}
                                            type='primary'
                                            size='md'
                                            buttonType="submit"
                                            fullWidth="fullWidth"
                                        />
                                    </div>
                                </form>
                                <div className="crdRowBlock mrgTop24">
                                    {/* <p className="pTxt">{l.backtologin}</p>
                                    <Link to="/" className="linkTxt linkTxtLg">{l.login}</Link> */}
                                    <Link to="/" className="fullTxtLink">
                                        {/* <img src="/images/icons/arrow.png" alt="icon" /> */}
                                        <span>{l.backtologin}</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>;
};

export default ResetPassword;
